import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=52cdc5fb&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=52cdc5fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cdc5fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52cdc5fb')) {
      api.createRecord('52cdc5fb', component.options)
    } else {
      api.reload('52cdc5fb', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=52cdc5fb&scoped=true&", function () {
      api.rerender('52cdc5fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2qQkPUOA432q7/JS/comp/PopupBox.vue"
export default component.exports